import i18n from 'config/i18n';
import { getLocale } from 'utils/date';
import { GetShortCutsProps } from './utils.types';
import { MrpShortcuts } from 'components/mrp/mrp.consts';
import { ShortcutAction } from 'components/shared/ShortcutProvider';
import { getPlatform } from 'components/shared/Typography/Kbd/Kbd.utils';

const t = i18n.getFixedT(getLocale(), null, 'mrp.shortcuts.interaction');

export const getShortCuts = ({
  cutEvent,
  copyEvent,
  cancelInteraction,
  pasteEvent,
  duplicateEvent,
  duplicateRecurringEvent,
  openEntityQuickConnect,
  openEntityQuickDisconnect,
  openAppointment,
  deleteAppointment,
  canEditAppointment,
  hasAddAppointmentAccess
}: GetShortCutsProps): ShortcutAction[] => {
  return [
    {
      name: 'activate',
      label: t('editAppointment.label'),
      description: t('editAppointment.description'),
      callback: openAppointment,
      active: canEditAppointment && hasAddAppointmentAccess,
      ...MrpShortcuts.EDIT_APPOINTMENT
    },
    {
      name: 'cutEvent',
      label: t('cut.label'),
      description: t('cut.description'),
      callback: cutEvent,
      active: canEditAppointment && hasAddAppointmentAccess,
      ...MrpShortcuts.CUT_APPOINTMENT
    },
    {
      name: 'copyEvent',
      label: t('copy.label'),
      description: t('copy.description'),
      callback: copyEvent,
      active: hasAddAppointmentAccess,
      ...MrpShortcuts.COPY_APPOINTMENT
    },
    {
      name: 'cancelInteraction',
      label: t('cancelInteraction.label'),
      description: t('cancelInteraction.description'),
      callback: cancelInteraction,
      activatorKey: 'ESCAPE',
      controllerKeys: []
    },
    {
      name: 'pasteEvent',
      label: t('paste.label'),
      description: t('paste.description'),
      callback: pasteEvent,
      active: hasAddAppointmentAccess,
      ...MrpShortcuts.PASTE_APPOINTMENT
    },
    {
      name: 'duplicateEvent',
      label: t('duplicate.label'),
      description: t('duplicate.description'),
      callback: duplicateEvent,
      active: hasAddAppointmentAccess,
      ...MrpShortcuts.DUPLICATE_APPOINTMENT
    },
    {
      name: 'duplicateRecurringEvent',
      label: t('duplicateRecurring.label'),
      description: t('duplicateRecurring.description'),
      callback: duplicateRecurringEvent,
      active: hasAddAppointmentAccess,
      ...MrpShortcuts.DUPLICATE_RECURRING_APPOINTMENT
    },
    {
      name: 'entityQuickConnect',
      label: t('entityQuickConnect.label'),
      description: t('entityQuickConnect.description'),
      callback: openEntityQuickConnect,
      active: canEditAppointment && hasAddAppointmentAccess,
      ...MrpShortcuts.QUICK_CONNECT
    },
    {
      name: 'entityQuickDisconnect',
      label: t('entityQuickDisconnect.label'),
      description: t('entityQuickDisconnect.description'),
      callback: openEntityQuickDisconnect,
      active: canEditAppointment && hasAddAppointmentAccess,
      ...MrpShortcuts.QUICK_DISCONNECT
    },
    {
      name: 'deleteAppointment',
      label: t('delete.label'),
      description: t('delete.description'),
      callback: deleteAppointment,
      active: canEditAppointment && hasAddAppointmentAccess,
      ...(getPlatform() === 'mac'
        ? MrpShortcuts.DELETE_APPOINTMENT_MAC_OS
        : MrpShortcuts.DELETE_APPOINTMENT)
    }
  ];
};
